import ymaps from "ymaps";

export default class YMap {
	constructor(id, event) {
		this._id = id;
		this._event = event;
		this._$ = document.getElementById(id);
		this._options = Object.assign(this.loadOptionsDefault(), { ...this._$.dataset });
		this._defaultIcon = this.createIcon();
		this._listMarkers = {};
		this._markers = Array.from(this._$.querySelectorAll("[data-x]"))
			.filter((point) => point.dataset.x && point.dataset.y)
			.map((point) => ({
				desc: point.innerHTML.trim() || false,
				...point.dataset,
			}));

		this.init().then(() => this._markers.forEach((point) => this.addMarker(point)));
	}

	async init() {
		await ymaps
			.load("//api-maps.yandex.ru/2.1/?lang=ru_RU")
			.then((maps) => {
				this._maps = maps;
				this._map = new maps.Map(this._id, {
					center: [this._options.centerX, this._options.centerY],
					zoom: this._options.zoom,
					controls: ["zoomControl", "fullscreenControl"],
				});
			})
			.catch((error) => console.log("Failed to load Yandex Maps", error));

		if (!this._options.isScroll) this._map.behaviors.disable("scrollZoom"); // проверяем, надо ли отрубать скролл
		this._event(this);
	}

	/**
	 * Загрузить список опций по умолчанию
	 *
	 * @returns {{iconHeight: number, ico: string, iconWidth: number, isScroll: boolean, zoom: number, api: string, desc: string}}
	 */
	loadOptionsDefault() {
		return {
			zoom: 16,
			ico: "/assets/img/point-map.svg",
			iconWidth: 30,
			iconHeight: 30,
			isScroll: false,
		};
	}

	createIcon(ico) {
		return {
			url: ico || this._options.ico,
			size: [this._options.iconWidth, this._options.iconHeight],
			imgOffset: [-this._options.iconWidth / 2, -this._options.iconHeight],
			contentOffset: [0, 0],
		};
	}

	addMarker(point) {
		// const iconPoint = point.ico ? this.createIcon(point.ico) : this._defaultIcon;
		const newMarker = new this._maps.Placemark([point.x, point.y], {
			hintContent: "",
			balloonContent: point.desc,
		}, {
			preset: "islands#dotIcon",
			iconColor: "#64A70B",
			// iconLayout: point.desc ? "default#imageWithContent" : "default#image",
			// iconImageHref: iconPoint.url,
			// iconImageSize: iconPoint.size,
			// iconImageOffset: iconPoint.imgOffset,
			// iconContentOffset: iconPoint.contentOffset,
		});

		this._listMarkers[`${point.x}-${point.y}`] = newMarker;
		this._map.geoObjects.add(newMarker);
	}
}
